<template>
  <div class="flex h-screen font-light transition-colors duration-200" :class="themeClasses.app">
    <NavbarView  v-if="route.path !== '/login' && !route.path.startsWith('/reset-password/')" class="w-64 border-r sidebar" :class="themeClasses.navbar" />

    <main class="flex-1 overflow-auto flex flex-col relative" :class="themeClasses.main">
      <MobileNavbar v-if="route.path !== '/login' && !route.path.startsWith('/reset-password/')" class="mobile-navbar" />

      <router-view class="flex-1" />
    </main>

  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import NavbarView from './components/NavbarView.vue'
import MobileNavbar from './components/MobileNavbar.vue'
import { useTheme } from '@/composables/useTheme'
import api from '@/api'
import 'vue3-toastify/dist/index.css'

const route = useRoute()
const isSubscriptionActive = ref(true)

// Initialiser le système de thème
const { isDark } = useTheme()

// Classes dynamiques selon le thème
const themeClasses = computed(() => ({
  app: isDark.value
    ? 'bg-zinc-950 text-zinc-400'
    : 'bg-gray-50 text-gray-700',
  navbar: isDark.value
    ? 'bg-zinc-950 border-zinc-900 text-white'
    : 'bg-white border-gray-200 text-gray-900',
  main: isDark.value
    ? 'bg-zinc-950'
    : 'bg-gray-50'
}))

// Vérifier l'état de l'abonnement
const checkSubscriptionStatus = async () => {
  if (route.path === '/login' || route.path.startsWith('/reset-password/')) {
    return
  }

  const token = localStorage.getItem('token')
  if (!token) {
    console.log('Pas de token - utilisateur non authentifié')
    isSubscriptionActive.value = true 
    return
  }

  try {
    const response = await api.auth.getFirmInfo()
    const firm = response.data.data || response.data

    isSubscriptionActive.value = firm.isActive === true
    console.log('Statut abonnement BookMySalon:', firm.isActive, firm)
  } catch (error) {
    console.error('Erreur lors de la vérification de l\'abonnement:', error)
    isSubscriptionActive.value = true
  }
}



onMounted(() => {
  checkSubscriptionStatus()
})

watch(() => route.path, () => {
  checkSubscriptionStatus()
})
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

.bebas-neue-regular {
  font-family: "Bebas Neue", sans-serif;
}

/* Variables CSS pour le thème sombre */
:root.dark {
  --bg-primary: #09090b;
  --bg-secondary: #18181b;
  --bg-tertiary: #27272a;
  --border-primary: #27272a;
  --border-secondary: #3f3f46;
  --text-primary: #fafafa;
  --text-secondary: #a1a1aa;
  --text-tertiary: #71717a;
  --accent: #D5CCBC;
}

/* Variables CSS pour le thème clair */
:root.light {
  --bg-primary: #f9fafb;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f3f4f6;
  --border-primary: #e5e7eb;
  --border-secondary: #d1d5db;
  --text-primary: #111827;
  --text-secondary: #4b5563;
  --text-tertiary: #6b7280;
  --accent: #8B7355;
}

body {
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.dark body {
  background-color: #09090b;
  color: #a1a1aa;
}

.light body {
  background-color: #f9fafb;
  color: #4b5563;
}

p {
  font-weight: normal !important;
  font-family: "Poppins", sans-serif;
}

/* Media query pour écran < 768px (mobile) */
@media (max-width: 767px) {
  .sidebar {
    display: none !important;
  }
  .mobile-navbar {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}

@media (min-width: 768px) {
  .mobile-navbar {
    display: none;
  }
}
</style>